@if (passwordFieldValidators) {
<div class="password-rules my-2">
  <ng-container *ngFor="let passwordRule of keysOfPasswordRules; let i = index; trackBy: trackByRule">
    <div class="password-rule-row my-1">
      <div class="col m-0">
        <!-- Match template -->
        <ng-container *ngIf="isRulePassed(passwordRule)">
          <div [innerHTML]="getMatchTemplate(passwordRule) | safeHtml"></div>
        </ng-container>

        <!-- No Match template -->
        <ng-container *ngIf="!isRulePassed(passwordRule)">
          <div [innerHTML]="getNoMatchTemplate(passwordRule) | safeHtml"></div>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>
} @else {
<div class="mt-3">
  <div>
    <finxone-web-frontend-text-skeleton contentClass="mb-2 skeleton_100" />
  </div>
  <div>
    <finxone-web-frontend-text-skeleton contentClass="mb-2 skeleton_75" />
  </div>
</div>
}
